<template>
  <div class="tenant-account-page" v-if="$route.matched.length === 3">
    <div class="search-box">
      <a-form :form="searchForm" layout="inline">
        <a-form-item label="合同编号">
          <a-input placeholder="请输入合同编号" v-decorator="['contactNo']" />
        </a-form-item>
        <a-form-item label="租户名称">
          <a-input placeholder="请输入租户名称" v-decorator="['tenatName']" />
        </a-form-item>
        <a-form-item label="账单类型">
          <a-select
            style="width: 150px"
            placeholder="请选择账单类型"
            v-decorator="['billType']"
          >
            <a-select-option value="MANUAL">手动账单</a-select-option>
            <a-select-option value="SYSTEM">系统账单</a-select-option>
            <!-- <a-select-option value="3">解约账单</a-select-option> -->
          </a-select>
        </a-form-item>
        <a-form-item label="创建时间">
          <a-range-picker
            :placeholder="['开始时间', '结束时间']"
            v-decorator="['createTime']"
          />
        </a-form-item>
        <!-- <a-form-item label="结算周期">
          <a-range-picker
            :placeholder="['开始时间', '结束时间']"
            v-decorator="['time']"
          />
        </a-form-item> -->
      </a-form>
      <div class="btn-wrap">
        <a-button type="primary" @click="onSearch">搜索</a-button>
        <a-button
          type="default"
          style="margin-left: 20px"
          @click="searchForm.resetFields()"
          >重置</a-button
        >
      </div>
    </div>
    <div class="table-btn" id="table">
      <div class="btnGroup">
        <!-- <a-button type="primary" @click="openModal">新建查询</a-button> -->
        <a-button type="primary" @click="onExport">导出Excel</a-button>
      </div>
      <a-table
        rowKey="id"
        :scroll="{ x: 1100 }"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="pagination"
        @change="(pagination) => getAccountData(pagination.current - 1)"
      >
        <template slot="operation" slot-scope="record">
          <div class="handle">
            <a-tooltip title="查看详情">
              <div class="icon" @click="goViewDetail(record)">
                <i class="iconfont icon-chakan" />
              </div>
            </a-tooltip>
            <!-- <a-tag color="blue" class="view" @click="goViewDetail(record)"
              >查看详情</a-tag
            > -->
            <!-- <a-popconfirm title="确定删除吗？" okType="danger" okText="删除">
              <a-tag color='red'>删除</a-tag>
            </a-popconfirm> -->
          </div>
        </template>
      </a-table>
    </div>
    <a-modal
      class="search-modal"
      title="新建查询"
      width="700px"
      :visible="createSearchVisible"
      :maskClosable="false"
      @cancel="handleClose"
    >
      <a-form :form="form" :labelCol="{ span: 6 }" :wrapperCol="{ span: 12 }">
        <a-form-item label="租户名称">
          <a-select
            placeholder="请选择租户"
            v-decorator="[
              'tenatId',
              { rules: [{ required: true, message: '请选择租户' }] },
            ]"
            :showSearch="true"
            @search="getTenantData"
            @change="changeTenant"
          >
            <a-select-option
              v-for="item in tenantList"
              :key="item.id"
              :value="item.id"
              >{{ item.tenatName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="选择合同">
          <a-radio-group
            v-decorator="[
              'contractId',
              { rules: [{ required: true, message: '请选择合同' }] },
            ]"
          >
            <a-radio
              v-for="(item, index) in contractArr"
              :key="index"
              :value="item.id"
            >
              {{ item.contactNo || "" }} （{{ item.effectiveDate || "" }}~{{
                item.expireDate || ""
              }}）
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="账单日期">
          <a-range-picker
            v-decorator="[
              'time',
              { rules: [{ required: true, message: '请选择账单日期' }] },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
  <router-view v-else></router-view>
</template>
<script>
import { contractBillPage, tenantPage, contractPage } from "./service";
import moment from "moment";
import { domainStr } from "../../../utils/request";
import scrollbarInit from "../../../utils/perfectScrollBar";
const columns = [
  {
    title: "合同编号",
    dataIndex: "contactNo",
    width: 200,
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "租户姓名",
    dataIndex: "tenatName",
    ellipsis: true,
    width: 200,
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "联系方式",
    dataIndex: "contactPhone",
    width: 150,
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "账单类型",
    dataIndex: "billType",
    width: 150,
    customRender: (text) => {
      const stu = {
        MANUAL: "手动账单",
        SYSTEM: "系统账单",
      };
      return stu[text] || "--";
    },
  },
  {
    title: "总费用",
    dataIndex: "useNumber",
    width: 150,
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "账单创建时间",
    dataIndex: "dateCreated",
    width: 200,
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "账单结算开始时间",
    dataIndex: "preDate",
    width: 200,
    customRender: (text) => {
      return `${moment(text).format("YYYY-MM-DD") || "--"}`;
    },
  },
  {
    title: "账单结算结束时间",
    dataIndex: "endDate",
    width: 200,
    customRender: (text) => {
      return `${moment(text).format("YYYY-MM-DD") || "--"}`;
    },
  },
  {
    title: "操作",
    dataIndex: "",
    // fixed: "right",
    width: 100,
    scopedSlots: { customRender: "operation" },
  },
];
export default {
  data() {
    return {
      searchForm: this.$form.createForm(this),
      form: this.$form.createForm(this),
      columns,
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParams: {},
      contractArr: [],
      tenantList: [],

      createSearchVisible: false,
    };
  },
  created() {
    this.getAccountData();
  },
  mounted() {
    this.createScroll();
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.createScroll();
      });
    },
  },
  methods: {
    createScroll() {
      const scrollBar = scrollbarInit("#table");
      const dom = document.querySelector("#table");
      dom.scrollTop = 0;
      scrollBar.update();
    },
    openModal() {
      this.createSearchVisible = true;
      this.getTenantData();
    },
    handleClose() {
      this.form.resetFields();
      this.createSearchVisible = false;
      this.tenantList = [];
      this.contractArr = [];
    },
    goViewDetail(record) {
      //console.log(record);
      this.$router.push({
        path: "/app/signing/tenantaccount/detail",
        query: {
          accounts: JSON.stringify(record),
        },
      });
    },
    async getTenantData(val) {
      try {
        const params = {
          isPage: 0,
          tenatName: val,
        };
        const res = await tenantPage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          this.tenantList = res.data.items;
        }
      } catch (err) {
        console.error(err);
      }
    },
    changeTenant(val) {
      //console.log("change", val);
      this.contractArr = [];
      let tenantList = this.tenantList;
      tenantList.map((item) => {
        if (item.id === val) {
          this.getContractDATA(item.id);
        }
      });
    },
    async getContractDATA(tenatId) {
      try {
        const params = {
          isPage: 0,
          tenatId,
        };

        const res = await contractPage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          this.contractArr = res.data.items;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getAccountData(pageNo = 0) {
      try {
        const params = Object.assign(
          {
            pageNo,
            pageSize: 10,
          },
          this.searchParams
        );

        const res = await contractBillPage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          this.dataSource = res.data.pageData.items;
          const pagination = {
            current: res.data.pageData.pageNo + 1,
            pageSize: 10,
            total: res.data.pageData.totalCount,
          };
          this.pagination = pagination;
        }
      } catch (err) {
        console.error(err);
      }
    },
    onSearch() {
      const data = this.searchForm.getFieldsValue();
      const searchParams = {};
      Object.keys(data).map((key) => {
        if (key === "createTime" && data[key] && data[key].length > 1) {
          searchParams.timeFrom = moment(data[key][0]).format(
            "YYYY-MM-DD 00:00:00"
          );
          searchParams.timeTo = moment(data[key][1]).format(
            "YYYY-MM-DD 23:59:59"
          );
        } else {
          data[key] && (searchParams[key] = data[key]);
        }
      });
      this.searchParams = searchParams;
      this.getAccountData();
    },
    async onExport() {
      try {
        let url = `${domainStr}/v2/contract/bill/export`;
        let searchParams = this.searchParams;
        if (Object.keys(searchParams).length > 0) {
          url = url + "?";
          Object.keys(searchParams).map((key) => {
            if (searchParams[key]) {
              url = url + key + "=" + searchParams[key] + "&";
            }
          });
        }

        const a = document.createElement("a");
        a.href = url;
        a.download = "账单报表.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../utils/convertPxToDesighViewport/convertPxToDesighViewport";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]
.tenant-account-page {
  width: 100%;
  overflow: hidden;
  > .search-box {
    background: #192430;
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    padding: .convertPxToDesighVH(10) [] .convertPxToDesighVW(20) [];
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // justify-content: space-between;
    height: .convertPxToDesighVH(190) [];
    .btn-wrap {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
  > .table-btn {
    margin-top: .convertPxToDesighVH(20) [];
    background: #192430;
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    padding: .convertPxToDesighVH(20) [];
    // overflow: auto;
    height: calc(100vh - .convertPxToDesighVH(320) []);
    > .btnGroup {
      margin-bottom: .convertPxToDesighVH(20) [];
      display: flex;
      align-items: center;
      justify-content: flex-end;
      > .ant-btn {
        // margin-right: 20px;
      }
    }
    > .ant-table-wrapper {
      .handle {
        display: flex;
        .icon {
          width: .convertPxToDesighVW(40) [];
          height: .convertPxToDesighVH(40) [];
          background: #091121;
          border-radius: .convertPxToDesighVH(15) [];
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: .convertPxToDesighVW(24) [];
        }
        > .ant-tag {
          height: .convertPxToDesighVH(30) [];
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: .convertPxToDesighVH(14) [];
          font-family: Microsoft YaHei;
          font-weight: 300;
          margin-right: .convertPxToDesighVW(20) [];
        }
      }
    }
  }
}

#table {
  position: relative;
  overflow: hidden;
}
</style>
